<template>
  <div>
    <el-table
      :data="files"
    >
      <el-table-column
        prop="file"
        label="Fájl"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-image
            :src="getFileLogo(scope.row.extension)"
            fit="contain"
            style="width: 30px; height: 30px"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="file"
        label="Típus"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.extension }}
        </template>
      </el-table-column>
      <el-table-column
        prop="size"
        label="Méret"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.size | fileSize }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label=""
        width="170"
        style="text-align: right;"
      >
        <template
          slot-scope="scope"
        >
          <actions
            :file="scope.row"
            :dialog-type="dialogType"
            @delete="onDelete"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible="showDialog"
      title="Új fájl"
      append-to-body
      :close-on-click-modal="false"
      width="450px"
      @close="onClose"
      :key="dialogKey"
    >
      <file-form
        ref="fileForm"
      />
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="onClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          @click="storeFiles"
        >
          Hozzáadás
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Actions from './Actions';
  import FileForm from './Form';

  export default {
    components: { Actions, FileForm },
    props: ['files', 'showDialog', 'dialogType'],
    data() {
      return {
        dialogKey: 0,
      };
    },
    methods: {
      onClose() {
        this.$refs.fileForm.files = [];
        this.$refs.fileForm.fileList = [];
        this.$emit('closeDialog');
      },
      onDelete(file) {
        const files = this.files.filter(a => ((a.id && a.id !== file.id) || a.key !== file.key));
        this.$emit('change', files);
        this.$emit('delete', file);
      },

      getFileLogo(type) {
        switch (type) {
          case 'pdf':
            return '/img/fileTypes/pdf.svg';
          case 'doc':
            return '/img/fileTypes/doc.svg';
          case 'docx':
            return '/img/fileTypes/doc.svg';
          case 'xls':
            return '/img/fileTypes/xls.svg';
          case 'xlsx':
            return '/img/fileTypes/xls.svg';
          case 'txt':
            return '/img/fileTypes/txt.svg';
          case 'zip':
            return '/img/fileTypes/zip.svg';
          case 'csv':
            return '/img/fileTypes/csv.svg';
          default:
            return '/img/fileTypes/file.svg';
        }
      },


      async storeFiles() {
        const files = this.$refs.fileForm.files;
        if (files.length) {
          this.$emit('add', files);
          this.onClose();
        } else {
          this.$messageWrapper.warning('Fájl feltöltese kötelező');
        }
      },
    }
  };
</script>
